import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import axios from "axios";
import Form from "../components/Certification/Form";
import Docs from "../components/Certification/Docs";
import LoaderDots from "../components/loaderDots";
import { initGA, event } from "../components/analytics";

import CurrencyChecker from "../components/currencyChecker";

class Certification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formInputs: {
        certificateType: undefined,
        country: { label: undefined, value: undefined }
      },
      fee: undefined,
      currency: undefined,
      loading: false,
      docs: []
    };
  }

  componentDidMount() {
    initGA()
  }

  async fetchDocuments() {
    const { certificateType, country } = this.state.formInputs;

    let params = {
      isFirst: (certificateType === 'new' ? true : false),
      countryCode: country.value
    };

    await axios
      .get("/api/v1/athletes/certification_docs.json", {
        params: params,
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      .then(response => {
        this.setState({
          docs: ["membershipOk"].concat(response.data.documents),
          currency: CurrencyChecker(response.data.currency),
          fee: response.data.price
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  validateForm() {
    const { certificateType, country } = this.state.formInputs;

    if (!certificateType) return false;
    if (!country.value) return false;

    return true;
  }

  async handleSubmitEvent() {
    this.setState({ loading: true });

    if (await !this.validateForm()) {
      this.setState({ loading: false });
      return null;
    }

    await this.fetchDocuments();
    this.setState({ loading: false });
  }

  updateInputState(e) {
    let newState = Object.assign({}, this.state);
    newState["formInputs"][e.target.name] = e.target.value;

    this.setState(newState);
    this.sendGAEvent(e.target);
  }

  sendGAEvent(target) {
    const eventsCategory = 'Black Belt Certification'
    switch (target.name) {
      case 'certificateType':
        event(eventsCategory, 'Certificate type choose', target.value)
        break;
      case 'country':
        event(eventsCategory, 'Country choose', target.value.label)
        break;
      default:
        break;
    }
  }

  componentChooser() {
    if (this.state.loading) return <LoaderDots />;

    if (this.state.docs.length == 0) {
      return (
        <Form
          handleSubmitEvent={this.handleSubmitEvent.bind(this)}
          updateInputState={this.updateInputState.bind(this)}
          formInputs={this.state.formInputs}
        />
      );
    } else {
      return (
        <Docs
          docs={this.state.docs}
          choosedOptions={this.state.formInputs}
          currency={this.state.currency}
          fee={this.state.fee}
        />
      );
    }
  }

  render() {
    return <div className="col-sm-12">{this.componentChooser()}</div>;
  }
}

Certification.propTypes = {
  loading: PropTypes.bool,
  docs: PropTypes.instanceOf(Array),
  fee: PropTypes.number,
  currency: PropTypes.string,
  formInputs: PropTypes.shape({
    certificateType: PropTypes.string,
    country: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  })
};

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <Certification />,
    document.querySelector("#certification")
  );
});
